/**
 * Initial state values and factory functions
 */

import type { GameState, Stats, UIState } from "@/types/state";
import { OverlayType } from "@/types/state";
import { DEFAULT_FIXED_DELAY } from "@/config/timerConfig";

// -----------------------------------------------------------------------------
// Version
// -----------------------------------------------------------------------------

export const CURRENT_STATE_VERSION = 1;

// -----------------------------------------------------------------------------
// Default Stats
// -----------------------------------------------------------------------------

export const DEFAULT_STATS: Stats = {
    cash: 0,
    investments: 0,
    happiness: 5,
};

// -----------------------------------------------------------------------------
// Initial Game State
// -----------------------------------------------------------------------------

export const INITIAL_GAME_STATE: GameState = {
    version: CURRENT_STATE_VERSION,
    gameIsFinished:false,
    gameOverReason:"none",
    currentPhaseId: null,
    currentRoomVariant: null,
    completedPhaseMessages: 0,
    nextRoom:null,
    nextRoomVariant:null,
    stats: { ...DEFAULT_STATS },
    inventory: [],
    unlockedAchievements: [],
    completedPhaseIds: [],
    financeTypeId: null,
};

// -----------------------------------------------------------------------------
// Initial UI State
// -----------------------------------------------------------------------------

export const INITIAL_UI_STATE: UIState = {
    isPaused: false,
    activeOverlay: OverlayType.None,

    history: [],

    // Pending response - no response pending initially
    pendingResponse: null,

    // Queue timer - starts inactive
    queueTimerActive: false,
    queueTimerElapsed: 0,
    queueTimerDuration: DEFAULT_FIXED_DELAY,
    effectivePhaseMessageTotal: 0,

    // Message queue - starts empty, populated by startPhase
    currentMessage: null,
    revealedItemId:null,
    messageQueue: [],

    // Animation sequencer - starts idle
    postMessageAnimationQueue: [],
    currentPostMessageAnimationStep: null,
    pendingFollowUpMessage: null,
    darkOverlayVisible: false,
};

// -----------------------------------------------------------------------------
// Factory Functions
// -----------------------------------------------------------------------------

/**
 * Create a fresh game state (useful for reset)
 */
export function createInitialGameState(): GameState {
    return {
        ...INITIAL_GAME_STATE,
        stats: { ...DEFAULT_STATS },
        inventory: [],
        unlockedAchievements: [],
        completedPhaseIds: [],
        financeTypeId: null,
    };
}

/**
 * Create a fresh UI state
 */
export function createInitialUIState(): UIState {
    return {
        ...INITIAL_UI_STATE,
        history: [],
        messageQueue: [],
        postMessageAnimationQueue: [],
    };
}